import { atom } from 'jotai';

import { deviceDetailsAsyncAtom } from './deviceDetailsAsyncAtom';
import { isOtherDeviceAsyncAtom } from './isOtherDeviceAsyncAtom';
import { selectedRepairIdsAtom } from './selectedRepairIdsAtom';
import { selectedRepairTypeIdsAtom } from './selectedRepairTypeIdsAtom';

export const selectedRepairsAsyncAtom = atom(async (get) => {
  const selectedDeviceDetails = await get(deviceDetailsAsyncAtom);
  const selectedRepairTypeIds = get(selectedRepairTypeIdsAtom);
  const selectedRepairIds = get(selectedRepairIdsAtom);
  const isOtherDevice = await get(isOtherDeviceAsyncAtom);

  return selectedDeviceDetails?.repairs?.length === 1 &&
    selectedDeviceDetails.isBottomLevel &&
    !isOtherDevice
    ? [selectedDeviceDetails.repairs[0]]
    : (selectedDeviceDetails?.repairs || []).filter(
        (repair) =>
          selectedRepairTypeIds.includes(repair.repairType.id) ||
          selectedRepairIds.includes(repair.id)
      );
});
